import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    custom: Palette["primary"];
  }

  interface PaletteOptions {
    custom?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/IconButton" {
  interface IconButtonPropsColorOverrides {
    custom: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    custom: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4e77fb",
    },
    secondary: {
      main: "#f1f5ff",
    },
    error: {
      main: "#e53935",
    },
    custom: {
      main: "#677280",
      light: "#f9f9f9",
    },
    common: {
      white: "#ffffff",
      black: "#212121",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 430,
      md: 768,
      lg: 1200,
      xl: 1536,
    },
  },
});
